import { DEFAULT_LOCATIONS, EMSANA_CARE, DROPDOWN_AUTOCOMPLETE } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token a65285f779964781e60c2330528b574379bbb984',
  staging: 'Token cbb1cd9a1fad8d58763cfb8b80aeb6717ebe07bd',
  prod: 'Token 6cf906054f58ebca035f860d68dc1d9a484e6c9a',
};

const token = selectToken(apiTokens);

const emsanaCareConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'emsanacare',

  API_TOKEN: token,
  EMBOLD_CLIENT: EMSANA_CARE,
  SHOW_REGION_SELECTOR: true,
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Mesa },
  LOGIN_NETWORK_NAME: 'emsanaCareUserId',

  // content
  DISPLAY_NAME: 'EmsanaCare',
  FORM_VARIANT: DROPDOWN_AUTOCOMPLETE,
  NO_WELCOME_LINK: false,
};

export default emsanaCareConfig;
